"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocsTooltipContent = DocsTooltipContent;
var _react = _interopRequireDefault(require("react"));
var _BaseTooltip = require("../../baseComponents/BaseTooltip");
var _sanitizeHtml = _interopRequireDefault(require("../../utils/sanitizeHtml"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function DocsTooltipContent(_ref) {
  var _cleanContent;
  var data = _ref.data,
    classes = _ref.classes,
    showHeader = _ref.showHeader,
    showFooter = _ref.showFooter,
    linkTopicDataId = _ref.linkTopicDataId;
  var cleanedContent = (_cleanContent = (0, _sanitizeHtml.default)(data.content)) !== null && _cleanContent !== void 0 ? _cleanContent : '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showHeader && /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipHeader, {
    classes: classes.header
  }, data.title), /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipContent, {
    classes: classes.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: cleanedContent
    }
  })), showFooter && /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipFooter, {
    classes: classes.footer
  }, /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltipLink, {
    link: data.href,
    linkTopicDataId: linkTopicDataId,
    showExternalIcon: true
  }, "Learn more")));
}